import { Text } from '@vtex/admin-ui'

type RadioDescriptionProps = {
  title: React.ReactNode
  description: React.ReactNode
}
export const RadioDescription = (props: RadioDescriptionProps) => {
  const { title, description } = props

  return (
    <>
      <div>{title}</div>
      <Text variant="detail" tone="secondary">
        {description}
      </Text>
    </>
  )
}
